import { AppCard } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { createFileRoute } from "@tanstack/react-router";
import { VendorDocuments } from "./-internal_components/VendorDocuments";
import { Route as VendorRoute } from "./route";

const RouteComponent: React.FC = () => {
  const vendor = VendorRoute.useLoaderData();

  return (
    <AppCard>
      <VendorDocuments vendor={vendor} />
    </AppCard>
  );
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/vendors/$vendorId/documents",
)({
  component: RouteComponent,
});
